import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AgmCoreModule } from '@agm/core';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'app/services/device.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { DeviceRequestService } from 'app/services/device-request.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsModule } from 'ng2-charts';
import { RouterModule } from '@angular/router';
import { DateConvertService } from 'app/services/date-convert.service';
import { MatCardModule } from '@angular/material/card';
import { DashboardComponent } from './dashboard.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { ContainerDetailComponent } from './container-detail/container-detail.component';
import { NgApexchartsModule } from "ng-apexcharts";


@NgModule({
  declarations: [DashboardComponent,ContainerDetailComponent],
  imports: [
    ChartsModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    NgApexchartsModule,
    MatSelectModule,
    MatTableModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatChipsModule,
    MatExpansionModule,
    MatInputModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatRippleModule,
    RouterModule,
    NgxMatDatetimePickerModule,
    MatCheckboxModule,
    MatSortModule,
    MatCardModule,
    MatTabsModule,
    MatSnackBarModule,
    PipesModule,
    NgxChartsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule,
    AgmCoreModule.forRoot({
        apiKey: 'AIzaSyCkWE28RXRLscXo8iJbGfS1fiqcA1u0oZQ'
    })
  ],
  providers: [
    DeviceService,
    DateConvertService,
    DeviceRequestService
]
})
export class DashboardModule { }
